import Reflux from 'reflux'
export default Reflux.createActions(['focusChange','focusSet','currentGroupSet','currentGroupGet',
		'afterNewRecordDataGridFocusSet','switchToCurrentSetSelect','notifyDataGridCurrentGroup','holdFocusIn',
		'afterActiveRecord','scrollToAndFocus','clearSigned','globalClick']);


// WEBPACK FOOTER //
// ./src/actions/FocusActions.js